const handlePaywall = () => {
    const premium_content_container = document.querySelectorAll('[data-premium-content-target]');

    if (typeof rmgPaywall === 'undefined') {
        return false;
    }

    return rmgPaywall && premium_content_container !== 'undefined' && premium_content_container.length;
};

document.addEventListener("DOMContentLoaded", () => {

    if (handlePaywall()) {
        rmgPaywall.checkArticle(rmn_pwl_vars.post_id, {}, function (access, context) {
            if (!access) {
                return;
            }

            jQuery.ajax( {
                url      : rmn_pwl_vars.ajaxurl,
                data     : {
                    action: 'rmnpwl_get_content',
                    post_id: rmn_pwl_vars.post_id,
                    nonce: rmn_pwl_vars.nonce
                },
                type     : 'POST',
                dataType : 'json'
            } ).done( function ( response ) {
    
                if (true !== response.success) {
                    return;
                }
                
                let contentContainers = document.querySelectorAll('[data-premium-content-target]');

                if (contentContainers.length) {
                    rpfSetInnerHTML(contentContainers[0], response.data.content);
                    //contentContainers[0].innerHTML = response.data.content;

                    // dispatch event to allow code to be executed after loading the premium content
                    const event = new CustomEvent('rmn_paywall_frontend_content_loaded');
		            dispatchEvent(event);
                }
            });
        });
    }
});


function rpfSetInnerHTML(elm, html) {
    elm.innerHTML = html;
    
    Array.from(elm.querySelectorAll("script")).forEach( oldScriptEl => {
        const newScriptEl = document.createElement("script");
        
        Array.from(oldScriptEl.attributes).forEach( attr => {
            newScriptEl.setAttribute(attr.name, attr.value) 
        });
        
        const scriptText = document.createTextNode(oldScriptEl.innerHTML);
        newScriptEl.appendChild(scriptText);
        
        oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
    });
}
